import { getField, updateField } from 'vuex-map-fields';
import Map from '../../api/listing';

// initial state
const state = {
	error: false,
	loading: false,
	success: false,
	listing: [],
	selectedAgent: null,
	currentPage: 1,
	resource: '', // api url for specific page listing
	specification: {},
	initState: {},
};

// getters
const getters = {
	getField,
};

// actions
const actions = {
	updateError({ commit, rootState }, error) {
		commit('updateError', error);
	},
	updateSuccess({ commit, rootState }, success) {
		commit('updateSuccess', success);
	},
	updateLoading({ commit, rootState }, loading) {
		commit('updateLoading', loading);
	},
	selectAgent({ commit, rootState }, agentId) {
		commit('updateSelectedAgent', agentId);
	},
	setFilter({ commit, rootState }) {
		// call the api with update specification object
		Map.setFilter(data => {
			commit('setListing', data);
		}, { specification: state.specification, resource: state.resource });
	},
};

// mutations
const mutations = {
	updateField,
	updateError(state, error) {
		state.error = error;
	},
	updateSuccess(state, success) {
		state.success = success;
	},
	updateLoading(state, loading) {
		state.loading = loading;
	},
	clearListing(state) {
		state.listing = [];
		
		state.specification.MaxMiles = null;
		state.specification.AgentType = null;
		state.specification.Name = null;
		state.specification.StateCode = null;
		state.specification.Zipcode = null;

        // Reset URL parameters
        // Create URL
        let newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

        // Update URL
        window.history.pushState({ path: newurl }, '', newurl);
	},
	updateSelectedAgent(state, agentId) {
		if (state.selectedAgent === agentId) {
			state.selectedAgent = null;
		}
		else {
			state.selectedAgent = agentId;
        }
	},
	setInitData(state, result) {
		// on load of app, load in data
        state.initState = result;
        state.listing = result.Items;
        state.specification = { ...state.initState.Specification };
	},
	setResource(state, resource) {
		state.resource = resource;
	},
	updateSubFilters(state, { maxMiles, agentType }) {
		state.specification.MaxMiles = maxMiles;
		state.specification.AgentType = agentType;

		// Update url parameters
        if (window.history.pushState) {
            // Encode data for url parameters
            const encodeDataToURL = (data) => {
                const value = Object
                    .keys(data)
                    .map(value => `${value}=${encodeURIComponent(data[value])}`)
                    .join('&');

                return value;
            };

            // Function to remove null or empty values
            const removeEmpty = (obj) => {
                const newObj = [];

                Object.keys(obj).forEach(key => {
                    if (obj[key] && typeof obj[key] === 'object') {
                        newObj[key] = removeEmpty(obj[key]);
                    }
                    else if (obj[key] !== null && obj[key] !== '') {
                        if (obj[key] !== '999') {
                            newObj[key] = obj[key];
                        }
                    }
                });

                return newObj;
            };

            // Remove null items
            const specification = removeEmpty(state.specification);

            // Create URL
            let newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${encodeDataToURL(specification)}`;

            // Update URL
            window.history.pushState({ path: newurl }, '', newurl);
        }
        //---/ Update URL parameters
	},
    updateSpecification(state, param) {
		// on each input change, update the specification object
		for (const [key, value] of Object.entries(state.specification)) {
			if (param.key === key && param.value != null) {
				state.specification[key] = param.value;
			}
		}

        // Update url parameters
        if (window.history.pushState) {
            // Encode data for url parameters
            const encodeDataToURL = (data) => {
                const value = Object
                    .keys(data)
                    .map(value => `${value}=${encodeURIComponent(data[value])}`)
                    .join('&');

                return value;
            };

            // Function to remove null or empty values
            const removeEmpty = (obj) => {
                const newObj = [];

                Object.keys(obj).forEach(key => {
                    if (obj[key] && typeof obj[key] === 'object') {
                        newObj[key] = removeEmpty(obj[key]);
                    }
                    else if (obj[key] !== null && obj[key] !== '') {
                        if (obj[key] !== '999') {
                            newObj[key] = obj[key];
                        }
                    }
                });

                return newObj;
            };

            // Remove null items
            const specification = removeEmpty(state.specification);

            // Create URL
            let newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${encodeDataToURL(specification)}`;

            // Update URL
            window.history.pushState({ path: newurl }, '', newurl);
        }
        //---/ Update URL parameters
	},
	setListing(state, data) {
		// update listing and pagination after api call
		state.listing = data.Items;
		state.specification = data.Specification;
		state.currentPage = 1;
	},
	updatePageNumber(state, page) {
		state.currentPage = page;
		state.selectedAgent = null;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
